import { Collapse, Input, Typography } from 'antd';

import { AutopsyActSection } from '@/api/pathology/types';

import cl from './styles.module.scss';

interface IAutopsyActSectionsProps {
  sections: AutopsyActSection[];
  getText: (section: AutopsyActSection) => string;
  onChange: (key: string, text: string) => void;
  readOnly: boolean;
}

// Разделы акта: текст раздела и фрагменты расшифровки, из которых он собран
export const AutopsyActSections = ({
  sections,
  getText,
  onChange,
  readOnly,
}: IAutopsyActSectionsProps) => (
  <div className={cl.sections}>
    {sections.map((section) => {
      const fragments = section.sourceFragments ?? [];

      return (
        <div key={section.key} className={cl.section}>
          <Typography.Title level={5} className={cl.sectionTitle}>
            {`${section.orderNumber}. ${section.title}`}
          </Typography.Title>
          <Input.TextArea
            value={getText(section)}
            readOnly={readOnly}
            autoSize={{ minRows: 2, maxRows: 16 }}
            placeholder={readOnly ? undefined : 'Введите текст раздела'}
            onChange={(event) => onChange(section.key, event.target.value)}
          />
          <Collapse
            ghost
            size="small"
            collapsible={fragments.length ? undefined : 'disabled'}
            items={[
              {
                key: 'fragments',
                label: `Исходные фрагменты (${fragments.length})`,
                children: (
                  <ul className={cl.fragments}>
                    {fragments.map((fragment, index) => (
                      <li key={index}>
                        <Typography.Text type="secondary">{fragment}</Typography.Text>
                      </li>
                    ))}
                  </ul>
                ),
              },
            ]}
          />
        </div>
      );
    })}
  </div>
);
